var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.category !== null && _vm.category.constructor.name === 'Array' && _vm.category.length > 0 && _vm.category.some(function (child) {
    return child.constructor.name === 'Object';
  }) ? _c('div', {
    staticClass: "col-span-full grid grid-cols-12 gap-x-4 gap-y-5 mb-10"
  }, [_c('div', {
    staticClass: "col-span-full uppercase text-indigo-600 text-base mx-5 md:mx-10"
  }, [_vm._v("\n    " + _vm._s(_vm.name.includes('tasks') ? 'Tâches Principales' : _vm.name.includes('comportements') ? 'Comportement / Aptitudes' : _vm.name.includes('connaissances') ? 'Connaissances associées' : _vm.name.includes('pratiques') ? 'Pratiques Professionnelles' : _vm.name) + "\n  ")]), _vm._v(" "), _vm.getCriteria(true).length > 1 && _vm.getCriteria(true).length < 6 && false ? _c('CheckboxIndigo', {
    staticClass: "ml-10 col-span-full",
    attrs: {
      "libelle": "Mode simplifié",
      "value": _vm.jauge
    },
    on: {
      "input": _vm.toggleJauge
    }
  }) : _vm._e(), _vm._v(" "), _vm.category.length > 0 ? _c('div', {
    staticClass: "col-span-full"
  }, [!_vm.$isMobile() ? _c('div', [_c('div', {
    staticClass: "text-lg text-gray-600 grid grid-cols-10 gap-x-4 mx-10"
  }, [_c('div', {
    staticClass: "col-span-3"
  }, [_vm._v("\n          " + _vm._s(_vm.name.includes('tasks') ? 'Tâches' : _vm.name.includes('comportements') ? 'Capacités / Aptitudes...' : _vm.name.includes('connaissances') ? 'Théoriques, procédurales...' : _vm.name.includes('pratiques') ? 'Être capable de...' : _vm.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 text-center"
  }, [_vm._v("Auto-évaluation")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 text-center",
    class: {
      hidden: _vm.idPass == _vm.idUser
    }
  }, [_c('span', {
    class: {
      hidden: _vm.historyMode
    }
  }, [_vm._v("Dernière eval. ref.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 text-center"
  }, [_c('span', {
    class: {
      hidden: _vm.idPass == _vm.idUser
    }
  }, [_vm._v("Nouvelle eval. ref.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-1 text-center"
  }, [_c('span', {
    class: {
      hidden: _vm.idPass == _vm.idUser
    }
  }, [_vm._v("Comm.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-start-4 col-span-2 flex items-center justify-center",
    class: {
      hidden: _vm.idPass == _vm.idUser || _vm.historyMode,
      'cursor-help': !_vm.$can('comppro_auto_eval_read', _vm.idPass),
      'cursor-pointer': _vm.$can('comppro_auto_eval_read', _vm.idPass)
    },
    attrs: {
      "title": _vm.$can('comppro_auto_eval_read', _vm.idPass) ? null : 'Permission manquante'
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.$can('comppro_auto_eval_read', _vm.idPass) ? _vm.hide('auto_' + _vm.name) : null;
      }
    }
  }, [_c('icon', {
    staticClass: "h-3 w-4 text-pink-600",
    attrs: {
      "name": _vm.hiddenFields['auto_' + _vm.name] ? 'eye-off' : 'eye'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-3 text-sm select-none"
  }, [_vm._v("\n            " + _vm._s(_vm.hiddenFields['auto_' + _vm.name] ? 'Afficher' : 'Masquer') + "\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 flex items-center justify-center cursor-pointer",
    class: {
      hidden: _vm.idPass == _vm.idUser || _vm.historyMode
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.hide('last_' + _vm.name);
      }
    }
  }, [_c('icon', {
    staticClass: "h-3 w-4 text-pink-600",
    attrs: {
      "name": _vm.hiddenFields['last_' + _vm.name] ? 'eye-off' : 'eye'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-3 text-sm select-none"
  }, [_vm._v("\n            " + _vm._s(_vm.hiddenFields['last_' + _vm.name] ? 'Afficher' : 'Masquer') + "\n          ")])], 1)]), _vm._v(" "), _vm._l(_vm.category, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "odd:bg-indigo-100 odd:bg-opacity-50"
    }, [_c('div', {
      staticClass: "h-auto py-5 xl:min-h-24 2xl:min-h-32 grid grid-cols-10 gap-x-4 place-content-center items-center cursor-default mx-10"
    }, [_c('div', {
      staticClass: "col-span-full md:col-span-3 text-base font-normal flex flex-col items-start gap-3"
    }, [_c('TextToSpeech', {
      attrs: {
        "speak": item.name
      }
    }), _vm._v(" "), _vm._v("\n            " + _vm._s(item.name) + "\n          ")], 1), _vm._v(" "), !_vm.hiddenFields['auto_' + _vm.name] && _vm.jauge ? _c('AnswerJauge', {
      staticClass: "md:col-span-2",
      attrs: {
        "disabled": false,
        "criteria": _vm.getCriteria(true),
        "reduced": false,
        "selected": _vm.form.items.activities[_vm.num][_vm.name][index].auto
      },
      on: {
        "select": function (newValue) {
          _vm.setAutoEvaluation(_vm.num, _vm.name, index, newValue !== undefined ? _vm.getCriteria(true)[newValue].value : undefined);
        }
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.hiddenFields['auto_' + _vm.name] || _vm.historyMode) && !_vm.jauge ? _c('input-select', {
      staticClass: "md:col-span-2 md:place-self-center",
      attrs: {
        "name": _vm.num + _vm.name + index + 'auto',
        "value": _vm.form.items.activities[_vm.num][_vm.name][index].auto,
        "datas": _vm.getCriteria(true),
        "disabled": _vm.autoEvalEditable || _vm.historyMode,
        "libelle": ""
      },
      on: {
        "input": function (newValue) {
          _vm.setAutoEvaluation(_vm.num, _vm.name, index, newValue);
        }
      }
    }) : _vm._e(), _vm._v(" "), _vm.hiddenFields['auto_' + _vm.name] ? _c('div', {
      staticClass: "col-span-full md:col-span-2"
    }) : _vm._e(), _vm._v(" "), _vm.idPass == _vm.idUser && !_vm.jauge ? _c('AnswerJauge', {
      attrs: {
        "disabled": false,
        "criteria": _vm.getCriteria(true),
        "reduced": false,
        "selected": _vm.form.items.activities[_vm.num][_vm.name][index].auto
      },
      on: {
        "select": function (newValue) {
          _vm.setAutoEvaluation(_vm.num, _vm.name, index, newValue !== undefined ? _vm.getCriteria(true)[newValue].value : undefined);
        }
      }
    }) : _vm._e(), _vm._v(" "), !_vm.historyMode && !_vm.hiddenFields['last_' + _vm.name] && _vm.idPass != _vm.idUser && false ? _c('input-text', {
      staticClass: "md:col-span-2 md:place-self-center",
      attrs: {
        "value": (((_vm.latestEval || {}).items || {}).activities || []).length > 0 ? ((((((_vm.latestEval || {}).items || {}).activities || [])[_vm.num] || {})[_vm.name] || [])[index] || {}).value === null ? 'Non noté' : ((((((_vm.latestEval || {}).items || {}).activities || [])[_vm.num] || {})[_vm.name] || [])[index] || {}).value || 'Pas d\'évaluation récente' : 'Pas d\'évaluation récente',
        "disabled": true,
        "libelle": ""
      }
    }) : _c('div', {
      staticClass: "col-span-full md:col-span-2"
    }), _vm._v(" "), _vm.idPass != _vm.idUser ? _c('input-select', {
      staticClass: "md:col-span-2 md:place-self-center",
      attrs: {
        "necessary": _vm.isNecessary,
        "name": _vm.num + _vm.name + index,
        "value": _vm.form.items.activities[_vm.num][_vm.name][index].value,
        "datas": _vm.getCriteria(false),
        "disabled": _vm.idPass == _vm.idUser || _vm.historyMode,
        "libelle": ""
      },
      on: {
        "input": function (newValue) {
          _vm.setReferentEvaluation(_vm.num, _vm.name, index, newValue);
        }
      }
    }) : _c('div', {
      staticClass: "col-span-full md:col-span-2"
    }), _vm._v(" "), _vm.idPass != _vm.idUser ? _c('icon-comment', {
      staticClass: "md:col-span-1 cursor-pointer md:place-self-center",
      attrs: {
        "name": 'comment-' + _vm.num + '-' + _vm.name + '-' + index,
        "value": _vm.form.items.activities[_vm.num][_vm.name][index].comment,
        "disabled": _vm.historyMode
      },
      on: {
        "input": function (newValue) {
          _vm.setComment(_vm.num, _vm.name, index, newValue);
        }
      }
    }) : _c('div', {
      staticClass: "col-span-full md:col-span-1"
    })], 1)]);
  })], 2) : _vm._e(), _vm._v(" "), _vm.$isMobile() ? _c('div', {
    staticClass: "mx-5"
  }, _vm._l(_vm.category, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "odd:bg-indigo-100 odd:bg-opacity-50"
    }, [_c('div', {
      staticClass: "h-auto py-5 min-h-16 lg:min-h-24 2xl:min-h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 items-center place-content-center",
      class: {
        'bg-indigo-200 border-l-2 border-indigo-600': _vm.itemDisplayed == index
      },
      attrs: {
        "id": 'category' + item.name + index
      },
      on: {
        "click": function ($event) {
          return _vm.displayItem(index, item.name);
        }
      }
    }, [_c('div', {
      staticClass: "col-span-2 text-pink-600 justify-self-center flex flex-col justify-around"
    }, [_c('icon', {
      staticClass: "transform transition-transform ease-in-out duration-300",
      class: {
        'rotate-90': _vm.itemDisplayed == index
      },
      attrs: {
        "name": "chevron-right"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-10 text-base line-clamp-3"
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])]), _vm._v(" "), _c('transition', {
      attrs: {
        "enter-active-class": "ease-out duration-300",
        "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
        "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
        "leave-active-class": "ease-in duration-200",
        "leave-class": "opacity-100 translate-y-0 sm:scale-100",
        "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.itemDisplayed === index,
        expression: "itemDisplayed === index"
      }],
      staticClass: "bg-white my-5 w-full relative flex flex-col space-y-4 px-5"
    }, [_c('TextToSpeech', {
      staticClass: "self-center",
      attrs: {
        "speak": item.name
      }
    }), _vm._v(" "), _c('input-text-area', {
      attrs: {
        "libelle": "Intitulé",
        "value": item.name,
        "disabled": true,
        "size": 3
      }
    }), _vm._v(" "), (!_vm.hiddenFields['auto_' + _vm.name] || _vm.historyMode) && !_vm.jauge ? _c('input-select', {
      attrs: {
        "name": _vm.num + _vm.name + index + 'auto',
        "disabled": _vm.autoEvalEditable || _vm.historyMode,
        "datas": _vm.getCriteria(true),
        "value": _vm.form.items.activities[_vm.num][_vm.name][index].auto,
        "libelle": "Auto-évaluation",
        "libelle-style": "text-base text-indigo-600",
        "libelle-icon": _vm.historyMode ? null : _vm.hiddenFields['auto_' + _vm.name] ? 'eye-off' : 'eye'
      },
      on: {
        "input": function (newValue) {
          _vm.setAutoEvaluation(_vm.num, _vm.name, index, newValue);
        },
        "clickIcon": function ($event) {
          _vm.$can('comppro_auto_eval_read', _vm.idPass) ? _vm.hide('auto_' + _vm.name) : null;
        }
      }
    }) : _vm._e(), _vm._v(" "), _vm.hiddenFields['auto_' + _vm.name] && !_vm.historyMode && !_vm.jauge ? _c('input-select', {
      attrs: {
        "name": _vm.num + _vm.name + index + 'auto',
        "disabled": true,
        "datas": _vm.getCriteria(true),
        "value": '',
        "libelle": "Auto-évaluation",
        "libelle-style": "text-base text-indigo-600",
        "libelle-icon": _vm.historyMode ? null : _vm.hiddenFields['auto_' + _vm.name] ? 'eye-off' : 'eye'
      },
      on: {
        "clickIcon": function ($event) {
          _vm.$can('comppro_auto_eval_read', _vm.idPass) ? _vm.hide('auto_' + _vm.name) : null;
        }
      }
    }) : _vm._e(), _vm._v(" "), !_vm.hiddenFields['auto_' + _vm.name] && _vm.jauge ? _c('AnswerJauge', {
      staticClass: "md:col-span-2",
      attrs: {
        "disabled": false,
        "criteria": _vm.getCriteria(true),
        "reduced": false,
        "selected": _vm.form.items.activities[_vm.num][_vm.name][index].auto,
        "libelle": "Auto-évaluation",
        "libelle-style": "text-base text-indigo-600",
        "libelle-icon": _vm.historyMode ? null : _vm.hiddenFields['auto_' + _vm.name] ? 'eye-off' : 'eye'
      },
      on: {
        "select": function (newValue) {
          _vm.setAutoEvaluation(_vm.num, _vm.name, index, newValue !== undefined ? _vm.getCriteria(true)[newValue].value : undefined);
        },
        "clickIcon": function ($event) {
          _vm.$can('comppro_auto_eval_read', _vm.idPass) ? _vm.hide('auto_' + _vm.name) : null;
        }
      }
    }) : _vm._e(), _vm._v(" "), _vm.hiddenFields['auto_' + _vm.name] && _vm.jauge ? _c('AnswerJauge', {
      staticClass: "md:col-span-2",
      attrs: {
        "disabled": true,
        "criteria": _vm.getCriteria(true),
        "reduced": false,
        "libelle": "Auto-évaluation",
        "libelle-style": "text-base text-indigo-600",
        "libelle-icon": _vm.historyMode ? null : _vm.hiddenFields['auto_' + _vm.name] ? 'eye-off' : 'eye'
      },
      on: {
        "clickIcon": function ($event) {
          _vm.$can('comppro_auto_eval_read', _vm.idPass) ? _vm.hide('auto_' + _vm.name) : null;
        }
      }
    }) : _vm._e(), _vm._v(" "), !_vm.historyMode ? _c('input-text', {
      attrs: {
        "name": index + 'derniere_eval',
        "disabled": true,
        "value": _vm.hiddenFields['last_' + _vm.name] ? '' : (((_vm.latestEval || {}).items || {}).activities || []).length > 0 ? ((((((_vm.latestEval || {}).items || {}).activities || [])[_vm.num] || {})[_vm.name] || [])[index] || {}).value === null ? 'Non noté' : ((((((_vm.latestEval || {}).items || {}).activities || [])[_vm.num] || {})[_vm.name] || [])[index] || {}).value || 'Pas d\'évaluation récente' : 'Pas d\'évaluation récente',
        "libelle": "Dernière évaluation du référent",
        "libelle-style": "text-base text-indigo-600",
        "libelle-icon": _vm.hiddenFields['last_' + _vm.name] ? 'eye-off' : 'eye'
      },
      on: {
        "clickIcon": function ($event) {
          return _vm.hide('last_' + _vm.name);
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('input-select', {
      class: {
        hidden: _vm.idPass == _vm.idUser
      },
      attrs: {
        "name": _vm.num + _vm.name + index,
        "necessary": _vm.isNecessary,
        "datas": _vm.getCriteria(false),
        "value": _vm.form.items.activities[_vm.num][_vm.name][index].value,
        "disabled": _vm.idPass == _vm.idUser || _vm.historyMode,
        "libelle": "Nouvelle évaluation du référent",
        "libelle-style": "text-base text-indigo-600"
      },
      on: {
        "input": function (newValue) {
          _vm.setReferentEvaluation(_vm.num, _vm.name, index, newValue);
        }
      }
    }), _vm._v(" "), _c('input-text-area', {
      attrs: {
        "name": 'comment-' + _vm.num + '-' + _vm.name + '-' + index,
        "libelle": "Commentaire",
        "value": _vm.form.items.activities[_vm.num][_vm.name][index].comment,
        "size": 3,
        "disabled": _vm.historyMode
      },
      on: {
        "input": function (newValue) {
          _vm.setComment(_vm.num, _vm.name, index, newValue);
        }
      }
    })], 1)])], 1);
  }), 0) : _vm._e()]) : _vm._e()], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }